
















import Vue, { PropType } from 'vue'
import { TableField } from '@/pages/dictionary/themes/list/types'
import { FiltersParams } from '@/pages/common/types'
import HeaderPopup from '@/pages/common/parts/header/header-popup/HeaderPopup.vue'
import DownloadButton from '@/pages/common/parts/header/DownloadButton.vue'
import { taskLoader } from '@/pages/results/courses-all/result-courses-all.model'
import { $permissions } from '@/features/session'

export default Vue.extend({
  components: {
    HeaderPopup,
    DownloadButton,
  },
  effector: {
    isLoadingExport: taskLoader.store.$exportTaskLoading,
    $permissions,
  },
  props: {
    tableColumns: { type: Array as PropType<TableField[]> },
  },
  methods: {
    setItem(filter: FiltersParams) {
      this.$emit('changeFilter', filter)
      this.$emit('setFilter')
    },
  },
})
